// 渠道信息
const state = {
    channel: window.sessionStorage.getItem('channel'),//当前渠道（默认城市房产公众号）
    defaultChannel: 'cityhouse.mobile.agent.gjh', //缺省渠道信息
}
const getters = {
    getUrlParam: () => (name) => {
        let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
        let r = window.location.search.substr(1).match(reg);  //匹配目标参数
        if (r != null) {
            return decodeURI(r[2]);
        }
        return null; //返回参数值
    },
    getRealChannel: (state, getters) => (isReal) => {
        // 0、优先读state的渠道信息
        if (state.channel) {
           return state.channel;
        }
        // 1、读取参数里面的渠道信息
        let urlChannel = getters.getUrlParam('state');
        if (urlChannel) {
           return urlChannel;
        }
        // 2、如果以上都没有值，并且不需要默认值，则返回空
        if (isReal) {
           return '';
        }
        return state.defaultChannel;
    },
    getChannel (state, getters) {
        return getters.getRealChannel(false);
    },
}
const mutations = {
    updateChannel(state, channel) {
        state.channel = channel;
        window.sessionStorage.setItem('channel', channel);
    }
}
const actions = {
    updateChannel({commit}, channel) {
        commit('updateChannel', channel);
    },
}
export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Channel.js